import axios from 'axios';
import { IBrand } from '../../../interfaces/Brand.interfaces';
import { IMachine } from '../../../interfaces/Machine.interfaces';
import { customAxios } from '../../common/customAxios';
import { IMarketPrice } from '../../../interfaces/MarketPrice.interfaces';
import { machinePriceStatisticsApiUrl } from './getMachinePriceStatistics';
import { IProduct } from '../../../interfaces/Product.interfaces';

export interface IGetMachinePriceStatisticsParam {
  machineId: string;
}

interface ISellPrice {
  manufacturedYear: number;
  operationTime: number;
  createdAt: string;
  price: number;
}

interface INewTractorPrice {
  year: number;
  price: number;
}

interface ISuggestedPrice {
  manufacturedYear: number;
  operationTime: number;
  createdAt: string;
  price: number;
}

export interface IGetMachinePriceStatisticsByIdReturn extends IMarketPrice {
  sellPrices: ISellPrice[];
  newTractorPrices: INewTractorPrice[];
  relatedProducts: IProduct[];
  relatedTractorMarketPrice: IMarketPrice[];
  suggestedPrices: ISuggestedPrice[];
}

export const getMachinePriceStatisticsById = ({
  machineId,
}: IGetMachinePriceStatisticsParam): Promise<IGetMachinePriceStatisticsByIdReturn | null> => {
  return customAxios.get(`${machinePriceStatisticsApiUrl}/${machineId}`);
};
